import {Truncate} from '@primer/react'
import type {AuthorSettings} from '../contexts/AuthorSettingsContext'

import styles from './AuthorDisplayName.module.css'

/**
 * Renders the display name of an author. This happens when the author does not have a login.
 */
export function AuthorDisplayName({
  displayName,
  authorSettings,
}: {
  displayName: string
  authorSettings: AuthorSettings
}) {
  return (
    <Truncate title={displayName} className={styles.truncate} inline>
      <span
        className={styles.Text}
        style={{
          '--author-font-weight': authorSettings.fontWeight,
          '--author-font-color': authorSettings.fontColor,
        }}
      >
        {displayName}
      </span>
    </Truncate>
  )
}
